// Let's get things done quickly by this hacky way first
const stage = process.env.REACT_APP_ENV || "development";

// eslint-disable-next-line import/no-mutable-exports
let environment: {
  STAGE: string;
  SENTRY_DSN: string;
  SENTRY_ENABLED: boolean;
  API: {
    TIMEOUT: number;
    HOST: string;
  };
  GOOGLE_CLIENT_ID: string;
  RECAPTCHA_SITE_KEY: string;
  URL: string;
  HOMEPAGE: string;
};
switch (stage) {
  case "production":
    environment = {
      STAGE: stage,
      SENTRY_DSN: "https://3de7eadc79d9494791027e0a0069b70f@o4505385335390208.ingest.sentry.io/4505385338601472",
      API: {
        TIMEOUT: 60000,
        HOST: "https://api.bettershot.ai",
      },
      SENTRY_ENABLED: true,
      GOOGLE_CLIENT_ID: "828168746010-0vvjdai7re3ho97cs7ll4k0r0oimahno.apps.googleusercontent.com",
      RECAPTCHA_SITE_KEY: "6Lfx2iQsAAAAANKbVKcS875JyFSJJOhhX2Jlic9H",
      URL: "https://app.bettershot.ai",
      HOMEPAGE: "https://www.bettershot.ai",
    };
    break;

  case "staging":
    environment = {
      STAGE: stage,
      SENTRY_DSN: "https://3de7eadc79d9494791027e0a0069b70f@o4505385335390208.ingest.sentry.io/4505385338601472",
      API: {
        TIMEOUT: 60000,
        HOST: "https://stg-api.bettershot.ai",
      },
      SENTRY_ENABLED: true,
      GOOGLE_CLIENT_ID: "828168746010-2rpt932hk6es0q5r82ripegshqvd8rms.apps.googleusercontent.com",
      RECAPTCHA_SITE_KEY: "6Lf9xiQsAAAAAMpbaUbNR9hDSsFvhQEumbEwhlWA",
      URL: "https://app-stg.bettershot.ai",
      HOMEPAGE: "https://stg.bettershot.ai",
    };
    break;

  case "test":
  case "development":
  default:
    environment = {
      STAGE: stage,
      SENTRY_DSN: "https://3de7eadc79d9494791027e0a0069b70f@o4505385335390208.ingest.sentry.io/4505385338601472",
      API: {
        TIMEOUT: 60000,
        HOST: "http://localhost:9020",
      },
      SENTRY_ENABLED: false,
      GOOGLE_CLIENT_ID: "828168746010-2rpt932hk6es0q5r82ripegshqvd8rms.apps.googleusercontent.com",
      RECAPTCHA_SITE_KEY: "6Lf9xiQsAAAAAMpbaUbNR9hDSsFvhQEumbEwhlWA",
      URL: "http://localhost:3000",
      HOMEPAGE: "https://stg.bettershot.ai",
    };
    break;
}

export default environment;
